module.exports = __webpack_public_path__ + "static/media/diametro.5bfccc24.png";